import React from 'react'
import "./ProductDetail93.css";
function ProductDetail93() {
  return (
    <>
    <div className='container-fluid p-5 bac'>
        <h5 className='text-center bluee'>The Challenge</h5>
        <h1 className='text-center txtf'><span className='chl'>Challenges in</span><br></br><span className='txt1'>Traditional Toll Systems</span></h1>
        <div className='row pt-5'>
        <div className='col-12 col-sm-6 col-md-4'>
        <div className=' p-4 bgi'>
            <h5 className='text-center challengeh'>Manual Classification Errors</h5>
            <p className='txttt'>Human operators misclassify vehicles, leading to wrong toll amounts and daily revenue loss across every lane.</p>
        </div>
        </div>
        <div className='col-12 col-sm-6 col-md-4'>
        <div  className=' p-4 bgi'>
           <h5 className='text-center challengeh'>Inaccurate FASTag Transactions</h5>
           <p className='txttt'>Transaction mismatches go undetected, causing unresolvable disputes and unrecovered revenue leakage.</p>
        </div>
        </div>
        <div className='col-12 col-sm-6 col-md-4'>
        <div  className=' p-4 bgi'>
            <h5 className='text-center challengeh'>No Centralized Control</h5>
            <p className='txttt'>Multiple plazas operate in silos — no unified dashboard, no cross-plaza data, no single point of truth.</p>
        </div>
        </div>
        </div>
        <div className='row pt-5'>
        <div className='col-12 col-sm-6 col-md-4'>
        <div className=' p-4 bgi'>
            <h5 className='text-center challengeh'>Manual Classification Errors</h5>
            <p className='txttt'>Human operators misclassify vehicles, leading to wrong toll amounts and daily revenue loss across every lane.</p>
        </div>
        </div>
        <div className='col-12 col-sm-6 col-md-4'>
        <div  className=' p-4 bgi'>
           <h5 className='text-center challengeh'>Fraudulent Exemptions</h5>
           <p className='txttt'>Unauthorized vehicles claim fake exemptions, bypassing payment with zero automated verification in place.</p>
        </div>
        </div>
        <div className='col-12 col-sm-6 col-md-4'>
        <div  className=' p-4 bgi'>
            <h5 className='text-center challengeh'>No Real-Time Monitoring</h5>
            <p className='txttt'>Supervisors have zero live visibility into lane activity, creating dangerous operational blind spots.</p>
        </div>
        </div>
        </div>
    </div>
    </>
  )
}

export default ProductDetail93
